import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { AlertSpan } from "../common/CommonStyled";

// 조건을 받아서 해당 조건이 맞는지 검증하여 값을 반환하는 InputBox

// LengthRegex와 Regex 조건을 받음
// 각각 길이와 문자 정규 문자열 검증
// LengthSpan과 RegexSpan을 받아 각 조건에 맞지 않을시 해당 문자열을 렌더링
// 필요시 Regex 및 Span을 Props에 추가해 커스텀할 것
// ref로 값을 상위에 전달
// setCond로 값이 검증을 모두 통과했는지 여부를 상위에 전달
// handleBlur로 정확한 값을 ref값을 상위 컴포넌트에 전달

// 리렌더를 최소화하기 위해 만들었으나, 결론적으로 맞는 값이 들어가면 포커스를 잃을때마다 전체 페이지를 리렌더해야함
// 경우에 따라서 사용하되, 전역저장소를 사용하는 것이 리렌더를 줄이는 데에는 더 효과적일 것...
// 다른 컴포넌트로부터 파생해서 개발한 컴포넌트다보니 Props가 사용하지 않는 기능까지 포함되어 있음 >> Props 다이어트 필요

const Container = styled.input<{ $isValid?: boolean, $disabled? :boolean }>`
  border-radius : 5px;
  border: 1px solid 
  ${({ $isValid, $disabled }) =>
      $disabled
        ? "#DDDDDD" // ✅ disabled일 때 border
        : $isValid === undefined || $isValid === null
        ? "#ccc"
        : $isValid
        ? "#ccc"
        : "#FF5A5A"};
  font-size: 16px;
  width: 100%;
  display: block;
  flex-grow: 1;
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: ${({ $disabled })=> $disabled ? '#F5F5F5': 'white'};
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
`

interface Props {
  type? :string;
  defaultValue?: string; 
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isValid? : boolean;
  value? : string;
  disabled? : boolean;
  setCond? : React.Dispatch<React.SetStateAction<boolean>>
  lengthRegex?: RegExp,
  lengthSpan?: string;
  regex0? : RegExp,
  regex0Span?: string
}

const InputBoxOnChangeValid = ({ placeholder, defaultValue, type , isValid, value, disabled, setCond, lengthRegex, lengthSpan, regex0, regex0Span, onChange }: Props) => {
  const [isLength,setIsLength] = useState(true)
  const [isRegex,setIsRegex] = useState(true)

  const handleChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
    const newValue = e.target.value;

    // 외부 onChange 호출
    onChange?.(e);

    // 내부 유효성 검사
    if (newValue.length !== 0) {
      const lengthValid = lengthRegex?.test(newValue) ?? true;
      setIsLength(lengthValid);

      if (lengthValid) {
        const regexValid = regex0?.test(newValue) ?? true;
        setIsRegex(regexValid);
      } else {
        setIsRegex(true); // 길이 안맞으면 regex 검사는 무시
      }
    } else {
      setIsLength(true);
      setIsRegex(true);
    }
  }
useEffect(()=>{
  setCond?.(isLength && isRegex)
},[isLength, isRegex])

  return (
    <Wrapper>
    <Container
      type={type}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={handleChange}
      $isValid={isValid}
      value={value}
      $disabled={disabled}
      disabled={disabled}
      // onBlur={handleBlur}
    />
    {!isLength ? <AlertSpan $isValid={false}>{lengthSpan}</AlertSpan>: !isRegex ? 
    <AlertSpan $isValid={false}>{regex0Span}</AlertSpan>:<></>}
    </Wrapper>
  );
};

export default InputBoxOnChangeValid;
